export default __webpack_public_path__ + "static/media/car 1.2b390016.svg";